import {
  FETCH_LIBRARY_CARDS_SUCCESS,
  CREATE_LIBRARY_CARD_SUCCESS,
  UPDATE_LIBRARY_CARD_SUCCESS,
  UPDATE_LIBRARY_CARD_FAILURE,
  DELETE_LIBRARY_CARD_SUCCESS,
  PRESIGNED_URL_SUCCESS,
  UPLOAD_FILE_SUCCESS,
  FETCH_METADATA_SUCCESS,
  LIST_CARDS_SUCCESS,
  FETCH_CARD_DETAILS_SUCCESS,
  GET_LIBRARY_CARD_TAGS_SUCCESS,
  GET_LIBRARY_CARD_TAGS_FAILURE,
  LIST_ENTITY_CARDS_SUCCESS,
  LIST_ENTITY_CARDS_FAILURE,
} from "../actions/libraryCardActions";

const initialState = {
  libraryCards: [], // Array of library cards
  presignedUrls: [], // Array of presigned URLs
  fileUploadResponse: null, // Response for uploaded files
  metadata: null, // Metadata for a library card
  cardDetails: null, // Detailed information for a specific library card
  listCards: [], // List of library cards for a tenant/entity type (legacy)
  libraryCardTags: null, // Tags for library cards
  entityCards: {}, // Entity-specific lists keyed by entityType
  loading: false,
  error: null, // Error state for operations
};

const libraryCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIBRARY_CARDS_SUCCESS:
      return {
        ...state,
        libraryCards: action.payload,
      };

    case CREATE_LIBRARY_CARD_SUCCESS:
      return {
        ...state,
        libraryCards: [...state.libraryCards, action.payload],
      };

    case UPDATE_LIBRARY_CARD_SUCCESS:
      return {
        ...state,
        libraryCards: state.libraryCards.map((card) =>
          card.entityId === action.payload.entityId ? action.payload : card
        ),
        loading: false,
        error: null,
      };

    case UPDATE_LIBRARY_CARD_FAILURE:
      console.error("UPDATE_LIBRARY_CARD_FAILURE:", action.payload);
      const errorMessage =
        action.payload?.message ||
        action.payload?.toString() ||
        "Failed to save";
      return {
        ...state,
        loading: false,
        error: errorMessage,
      };

    case DELETE_LIBRARY_CARD_SUCCESS:
      return {
        ...state,
        libraryCards: state.libraryCards.filter(
          (card) => card.entityId !== action.payload.entityId
        ),
      };

    case PRESIGNED_URL_SUCCESS:
      return {
        ...state,
        presignedUrls: action.payload,
      };

    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        fileUploadResponse: action.payload,
      };

    case FETCH_METADATA_SUCCESS:
      return {
        ...state,
        metadata: action.payload,
      };

    case LIST_CARDS_SUCCESS:
      return {
        ...state,
        listCards: action.payload.pageNames || action.payload,
      };

    case FETCH_CARD_DETAILS_SUCCESS:
      return {
        ...state,
        cardDetails: action.payload,
      };

    case GET_LIBRARY_CARD_TAGS_SUCCESS:
      return {
        ...state,
        libraryCardTags: action.payload.tags,
      };

    case GET_LIBRARY_CARD_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case LIST_ENTITY_CARDS_SUCCESS:
      const pageNames = action.payload.data.pageNames || action.payload.data;
      return {
        ...state,
        entityCards: {
          ...state.entityCards,
          [action.payload.entityType]: pageNames,
        },
        loading: false,
        error: null,
      };

    case LIST_ENTITY_CARDS_FAILURE:
      console.error(
        `libraryCardReducer - LIST_ENTITY_CARDS_FAILURE - entityType: ${action.payload.entityType}, error:`,
        action.payload.error
      );
      return {
        ...state,
        entityCards: {
          ...state.entityCards,
          [action.payload.entityType]: [],
        },
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default libraryCardReducer;
